import { c as _c } from "react/compiler-runtime";
import ChevronRight from '@mui/icons-material/ChevronRight';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { styled } from '@classify/react-core-components/styles';
import type { ContentData } from './Content/services';
const Root = styled(List)(({
  theme: {
    palette,
    radius,
    shadows
  }
}) => {
  const backgroundPrimary = (palette.background as typeof palette.background & {
    primary: string;
  }).primary;
  return {
    boxShadow: shadows.menu,
    borderRadius: radius.menu,
    '& .MuiListItemIcon-root': {
      minWidth: 0,
      color: palette.brand.primary
    },
    '& .MuiListItem-root': {
      '&:hover': {
        background: palette.primary.main,
        color: backgroundPrimary,
        '& svg': {
          color: backgroundPrimary
        }
      }
    }
  };
});
type MenuItem = ContentData | {
  isDivider: true;
};
type MenuProps = {
  items: ContentData[];
};
export default function Menu(t0) {
  const $ = _c(13);
  const {
    items
  } = t0;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== items) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const titles = items.reduce(_temp, []);
      if (titles.length === 0) {
        t4 = null;
        break bb0;
      }
      const handleClick = _temp2;
      t2 = "policy_menu";
      t3 = handleClick;
      T0 = Root;
      t1 = titles.map(_temp3).filter(Boolean);
    }
    $[0] = items;
    $[1] = T0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    T0 = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[6] !== T0 || $[7] !== t1) {
    t5 = <T0>{t1}</T0>;
    $[6] = T0;
    $[7] = t1;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t5) {
    t6 = <nav id={t2} onClick={t3}>{t5}</nav>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
function _temp3(item_0) {
  if ("isDivider" in item_0) {
    return null;
  }
  const id = item_0.anchor ? item_0.anchor : `policy_${item_0.id}`;
  return <ListItem disablePadding={true} key={id} component="a" href={`#_${id}`}><ListItemButton><ListItemText>{item_0.title?.replace(/<\/?.*?>/g, "")}</ListItemText><ListItemIcon><ChevronRight /></ListItemIcon></ListItemButton></ListItem>;
}
function _temp2(event) {
  if (!(event.target instanceof Element)) {
    return;
  }
  const target = event.target.closest("a");
  if (!target) {
    return;
  }
  const href = target.getAttribute("href");
  if (!href) {
    return;
  }
  const elementId = href.replace("#", "");
  const element = document.getElementById(elementId);
  if (!element) {
    return;
  }
  event.preventDefault();
  element.scrollIntoView({
    behavior: "smooth"
  });
}
function _temp(list, item) {
  if (item.content === "<hr>") {
    return [...list, {
      isDivider: true
    }];
  }
  if (!item.title) {
    return list;
  }
  if (item.title.startsWith("<h3") || item.title.startsWith("<h4")) {
    return list;
  }
  return [...list, item];
}